/**
 * External dependencies
 */
import React from 'react';
import { Box } from '@towersystems/towersystems-design-system';

const Divider = () => {
    return <Box className='button-group__divider'/>;
}

export default Divider;
    